import request from '@/utils/request'
var qs = require("qs")


export function addRegister(data) {
  return request({
    url: '/register/add',
    method: 'post',
    data:data
  })
}

export function getRegister() {
  return request({
    url: '/register',
    method: 'get'
  })
}

export function RegisterNameList() {
  return request({
    url: '/register/RegisterNameList',
    method: 'get'
  })
}

//修改注册信息
export function updateRegister(id, data) {
  return request({
    url: '/register/' + id,
    method: 'put',
    data: data
  })
}

//通过id查询注册信息
  export function query(id) {
    return request({
      url: '/register/' + id + '/query',
      method: 'get',
    })
  }






// WEBPACK FOOTER //
// ./src/api/register/register.js